module.exports = __webpack_public_path__ + "static/media/buf.a67679b1.png";